/* JB カードスライダー: PC用の矢印ボタンのみ（自動再生なし）。JS無効でもリンク一覧として使える。 */
(function () {
  function init(wrap) {
    if (wrap.dataset.jbCsReady) return;
    wrap.dataset.jbCsReady = '1';
    var vp = wrap.querySelector('[data-jb-cs-viewport]');
    var prev = wrap.querySelector('[data-jb-cs-prev]');
    var next = wrap.querySelector('[data-jb-cs-next]');
    if (!vp || !prev || !next) return;
    prev.hidden = false;
    next.hidden = false;
    function update() {
      prev.disabled = vp.scrollLeft <= 2;
      next.disabled = vp.scrollLeft >= vp.scrollWidth - vp.clientWidth - 2;
    }
    prev.addEventListener('click', function () { vp.scrollBy({ left: -vp.clientWidth * 0.8 }); });
    next.addEventListener('click', function () { vp.scrollBy({ left: vp.clientWidth * 0.8 }); });
    vp.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initAll(root) {
    (root || document).querySelectorAll('[data-jb-cs]').forEach(init);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
